import React from 'react'
import styled from 'styled-components'
import { fontSize, tabletMinWidth } from '../mixins'

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: ${({ onePage }) => onePage ? 'auto' : '160px'};
`

const StyledTitle = styled.h1`
  // max-width: 275px;
  font-weight: 600;
  ${fontSize(32)};
  font-size: clamp(24px,8vw,2rem);
  line-height: 38px;
  letter-spacing: -0.005em;
  text-align: center;
  color: #323232;
  margin: 0;

  @media screen and (min-width: ${tabletMinWidth}px) {
    // max-width: 373px;
    line-height: 44px;
  }
`

const StyledSubTitle = styled.p`
  // max-width: 320px;
  margin: 5px 0 0 0;
  font-weight: 400;
  ${fontSize(16)};
  line-height: 19px;
  text-align: center;
  letter-spacing: -0.005em;
  color: #323232;
`

const ScreenContent = (props) => {
  const { title, text, onePage } = props
  return (
    <StyledContainer onePage={onePage}>
      <StyledTitle>{title}</StyledTitle>
      <StyledSubTitle>{text}</StyledSubTitle>
    </StyledContainer>
  )
}

export default ScreenContent
